<!--临床好课 -->
<template>
    <div class="clinicCourse">
        <home-skeleton style="margin-top: 20px;margin-bottom: 100vh" v-if="loading"></home-skeleton>
        <div v-else>
            <div class="clinicCourse-search">
                <van-search class="header-search" v-model="value">
                    <template v-slot:left-icon>
                        <img src="/static/v4/search_icon.svg" alt="" style="margin-top: 5px" />
                    </template>
                </van-search>
                <div class="clinicCourse-search-swiper">
                    <van-swipe style="height: 36px;line-height: 36px" :autoplay="3000" vertical :show-indicators="false">
                        <van-swipe-item v-for="(item, index) in search_placeholder" :key="index" @click="jump(item)">
                            {{ item.title }}
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="clinicCourse-tag" ref="homeTags">
                <van-tabs v-model="category_index" @click="changeCategory" :ellipsis="false">
                    <van-tab v-for="(item,index) in categories" :key="index" :name="index" :title="item.title" ></van-tab>
                </van-tabs>
                <div class="clear"></div>
            </div>

            <img
                @click="goKf"
                class="course-detail-question-button"
                src="/static/v4/course_ex.svg"
                alt=""
            />
            <!--频道——推荐 -->
            <div v-if="category_index == 0" style="background: #F6F6F7;padding-top: 10px;padding-bottom: 60px">
                <div class="clinicCourse-swipe">
                    <van-swipe class="m-swipe" :autoplay="3000">
                        <van-swipe-item v-for="(item,i) in banners" :key="i" @click='goBanner(item)'>
                            <a :href="item.target_url">
                                <img :src="item.img" alt="">
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <!--课程上新 -->
                <div class="clinicCourse-new">
                    <div class="clinicCourse-new-title">
                        <div class="clinicCourse-new-title-left">
                            <span>课程上新</span>
                        </div>
                        <div class="clinicCourse-new-title-right" v-if="courseNewList.length > 1"
                             @click="$router.push('/clinic-list-new')">
                            <span>查看更多</span>
                            <img src="/static/v4/icon_home_news_more.svg">
                        </div>
                    </div>
                    <div class="clinicCourse-new-box">
                        <div class="clinicCourse-new-box-top">
                            <div class="clinicCourse-new-box-top-wrap" v-for="(item,index) in courseNewList" :key="index">
                                <div class="clinicCourse-new-box-top-wrap-first" v-if="index == 0" @click="goCourse(item)">
                                    <div class="clinicCourse-new-box-top-wrap-first-wrap">
                                        <img :src="item.cover_img" alt="">
                                    </div>
<!--                                    <div class="clinicCourse-new-box-top-wrap-first-bg"></div>
                                    <div class="clinicCourse-new-box-top-wrap-first-title">
                                        <span>{{ item.title }}</span>
                                    </div>
                                    <div class="clinicCourse-new-box-top-wrap-first-desc">
                                        <span>共{{ item.total_count }}期</span><span>{{ item.view_count }}人观看</span>
                                    </div>-->
                                </div>
                                <div class="clinicCourse-new-box-top-wrap-second" >
                                    <div v-if="index == 0" v-for="(i,ind) in item.items" :key="ind" class="clinicCourse-new-box-top-wrap-second-contain" @click="goCourseDetail(item,i)">
                                        <div class="clinicCourse-new-box-top-wrap-second-contain-item">
                                            <div class="clinicCourse-new-box-top-wrap-second-contain-item-img">
                                                <img :src="i.cover_img" alt="">
                                            </div>
                                            <div class="clinicCourse-new-box-top-wrap-second-contain-item-title">
                                                <span>{{ i.title }}</span>
                                            </div>
                                            <div class="clinicCourse-new-box-top-wrap-second-contain-item-desc">
                                                <span>{{ i.view_count }}人观看</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clinicCourse-new-box-bot">
                            <div class="clinicCourse-new-box-bot-wrap" v-for="(item,index) in courseNewList" :key="index" @click="goCourse(item)">
                                <div class="clinicCourse-new-box-bot-wrap-other" :class="[index == courseNewList.length - 1 ? 'chu' : '']" v-if="index > 0">
                                    <div class="clinicCourse-new-box-bot-wrap-other-left">
                                        <img :src="item.cover_img">
                                    </div>
                                    <div class="clinicCourse-new-box-bot-wrap-other-right">
                                        <div class="clinicCourse-new-box-bot-wrap-other-right-title">
                                            <span>{{ item.title }}</span>
                                        </div>
                                        <div class="clinicCourse-new-box-bot-wrap-other-right-desc">
                                            <span>共{{ item.total_count }}期</span>
                                            <span style="margin-left: 8px">{{ item.view_count }}人观看</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--推荐专栏 -->
                <div class="clinicCourse-recommend">
                    <div class="clinicCourse-recommend-title">
                        <span>推荐课程</span>
                    </div>
                    <van-list v-model="recommendLoading" :finished="recommendFinished" finished-text="已到底部" @load="onLoad">
                        <div class="clinicCourse-recommend-wrap">
                            <div class="clinicCourse-recommend-wrap-box" v-for="(item,index) in courseRecommend" :key="index"
                                 @click="goRecommend(item)">
                                <div class="clinicCourse-recommend-wrap-box-img">
                                    <img :src="item.cover_img" alt="">
                                </div>
                                <div class="clinicCourse-recommend-wrap-box-bot">
                                    <div class="clinicCourse-recommend-wrap-box-bot-title">
                                        <span>{{ item.title }}</span>
                                    </div>
                                    <div class="clinicCourse-recommend-wrap-box-bot-desc">
                                        <span>共{{ item.total_count }}期</span>
                                        <span>{{ item.view_count }}人观看</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </div>
            </div>
            <div v-else style="padding-bottom: 50px; background: #F6F6F7;">
                <van-list v-model="channelListLoading" :finished="channelListFinished" finished-text="已到底部" @load="channelListLoad">
                    <div class="clinicCourse-channel">
                        <div class="clinicCourse-channel-wrap">
                            <div class="clinicCourse-channel-wrap-box" v-for="(item,index) in courseChannelList" :key="index"
                                 @click="goChannel(item)">
                                <div class="clinicCourse-channel-wrap-box-img">
                                    <img :src="item.cover_img" alt="">
                                </div>
                                <div class="clinicCourse-channel-wrap-box-title">
                                    <span>{{ item.title }}</span>
                                </div>
                                <div class="clinicCourse-channel-wrap-box-desc">
                                    <span>共{{ item.total_count }}期</span>
                                    <span>{{ item.view_count }}人观看</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <!--底部tab -->
            <van-tabbar class="home-footer" :border="false" :fixed="true" :safe-area-inset-bottom="true" v-model="active" active-color="#D3172E">
                <van-tabbar-item to="/">
                    <span class="home-footer-span">首页</span>
                    <template #icon="props">
                        <div class="home-footer-icon-else">
                            <img src="/static/v4/icon_tab_home_2.svg" alt="">
                        </div>
                    </template>
                </van-tabbar-item>
                <van-tabbar-item to="live-list">
                    <span class="home-footer-span">直播</span>
                    <template #icon="props">
                        <div class="home-footer-icon">
                            <img src="/static/v4/icon_tab_live_2.svg" alt="">
                        </div>
                    </template>
                </van-tabbar-item>
                <van-tabbar-item to="clinic-course">
                    <span class="home-footer-span-else">临床好课</span>
                    <template #icon="props">
                        <div class="home-footer-icon">
                            <img src="/static/v4/icon_tab_course_1.svg" alt="">
                        </div>
                    </template>
                </van-tabbar-item>
                <van-tabbar-item to="my">
                    <span class="home-footer-span">我的</span>
                    <template #icon="props">
                        <div class="home-footer-icon-else">
                            <img src="/static/v4/icon_tab_me_2.svg" alt="">
                        </div>
                    </template>
                </van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>

<script>
import Interface from "@/util/interface"
import homeSkeleton from "@/skeleton/homeSkeleton"
import { liveList, courseList, academicList, downList, tagList, msgList } from '@/util/staticData'
export default {
    name: "index",
    components: {
        homeSkeleton
    },
    data() {
        return {
            loading: true,
            value: '',
            category_index: 0,
            categories: [],
            courseList: liveList,
            swiperOptionBanner:{
                width:375,
                height:98,
                spaceBetween:30,
                autoplay:true,
                loop:true,
            },
            banners: [],
            active: 0,
            courseNewList: [],
            courseRecommend: [], // 推荐专栏
            courseChannelList: [], // 频道列表
            channelListPage: 0,  // 频道列表分页数
            channelListLoading: false,
            channelListFinished: false,
            recommendLoading: false,
            recommendFinished: false,
            recommendPage: 0,
            search_placeholder: [],
        }
    },
    methods: {
        fetch(scene) {
            if (scene === 'banner') {
                Interface.getData('get', Interface.home).then((res) => {
                    this.recommend = res.data.recommend
                    this.fetch('tags')
                    setTimeout(() => {
                        this.loading = false;
                    }, 100)
                })
            } else if (scene === 'article') {
                let params = {
                    page: this.page,
                    pageSize: 10
                }
                Interface.getData('get', Interface.article.list, params).then((res) => {
                    this.articles = res.data.list
                    this.total_page = res.data.total_page
                })
            } else if (scene === 'tags') {
                let params = {
                    origin_type: 1
                }
                Interface.getData('get', Interface.v4.channel, params).then((res) => {
                    if (res.data.list) {
                        this.categories.push({id: 0, title: "推荐"})
                        this.categories.push(...res.data.list)
                        let search_channel = sessionStorage.getItem("clinic_course_channel")
                        if (this.$route.query.clinic_course_channel > 0) {
                            this.category_index = parseInt(this.$route.query.clinic_course_channel)
                            this.changeCategory()
                        } else if (search_channel != null) {
                            this.category_index = parseInt(search_channel)
                            this.changeCategory()
                        }
                    }
                })
            } else if (scene === 'channel_item') {
                if (this.category_index == 0) {
                    return
                }
                let params = {
                    origin_type: 1,
                    page: this.channelListPage,
                    pageSize: 10
                }
                Interface.getData('get', Interface.v4.channel_item + "/" + this.channel.id, params).then((res) => {
                    if (res.code == 0) {
                        if (res.data.list && res.data.list.length) {
                            this.courseChannelList.push(...res.data.list)
                        }
                        this.channelListLoading = false
                        if (this.channelListPage >= res.data.total_page) {
                            this.channelListFinished = true
                        }
                    }
                })
            } else if (scene === 'course') {
                Interface.getData('get', Interface.v4.course_new).then((res) => {
                    if (res.code == 0) {
                        this.courseNewList = res.data.list ? res.data.list : []
                    }
                })
            } else if (scene === 'search_text') {
                // 获取底纹词
                Interface.getData('get', Interface.v4.search_list, { type: 2 }).then(res => {
                    if (res.code == 0) {
                        this.search_placeholder = res.data.hot_words
                    }
                })
            } else if (scene === 'new_banner') {
                Interface.getData('get', Interface.v4.courser_banner, { type: 1}).then((res) => {
                    this.banners = res.data
                })
            }
        },
        changeCategory() {
            this.channelListPage = 0
            this.courseChannelList = []
            sessionStorage.setItem("clinic_course_channel",this.category_index)
            this.$router.push({
                name : "clinic-course",
                query: {
                    clinic_course_channel : this.category_index
                }
            })
            this.channel = this.categories[this.category_index]
            // document.title = '临床好课-' + this.channel.title
            if(this.category_index != 0){
                Interface.getShareInfo(this,'临床好课-' + this.channel.title,"","精选实用课，堂堂有收获")
            }
            if (this.channel.id) {
                Interface.mFootPrint(this.channel.id,32,0,3,0,this.channel.title)
            }
            // Interface.getShareInfo(this,'临床好课-' + this.channel.title,"精选实用课，堂堂有收获")
            this.channelListLoad()
        },
        // 频道分页加载
        channelListLoad() {
            this.channelListPage++
            this.fetch("channel_item")
        },
        // 推荐专栏分页加载
        onLoad() {
            this.recommendPage++
            let params = {
                page: this.recommendPage,
                pageSize: 10
            }
            Interface.getData('get', Interface.v4.course_recommend,params).then((res) => {
                if (res.code == 0) {
                    if (res.data.list && res.data.list.length) {
                        this.courseRecommend.push(...res.data.list)
                    }
                    this.recommendLoading = false
                    if (this.recommendPage >= res.data.total_page) {
                        this.recommendFinished = true
                    }
                }
            })
        },
        // 跳转到搜索页面
        jump(item) {
            this.$router.push({ path: '/search-new', query: { search: JSON.stringify(item),channel:"course" } })
        },
        // 推荐专栏跳转
        goRecommend(item) {
            if (item.source_type == 0) {
                // 跳转到课程专栏
                this.$router.push({ name: 'course-column', params: { id: item.id } })
            } else if (item.source_type == 4) {
                // 跳转到直播专栏  live-column
                this.$router.push({ name: 'live-column', params: { id: item.source_id } })
            }

        },
        // 课程上新专栏跳转
        goCourse(item) {
            if (item.source_type == 0) {
                // 跳转到课程专栏
                this.$router.push({ name: 'course-column', params: { id: item.course_id } })
            } else if (item.source_type == 4) {
                // 跳转到直播专栏  live-column
                this.$router.push({ name: 'live-column', params: { id: item.source_id } })
            }
        },
        // 课程上新一拖二详情页面跳转
        goCourseDetail(item,i) {
            if (item.source_type == 0) {
                // 跳转到课程详情
                this.$router.push({ name: 'course-detail', params: { id: i.id } })
            } else if (item.source_type == 4) {
                if (i.live_status == 6) {
                    this.$router.push({ name: 'live-detail-home', params: { id: i.id } })
                } else {
                    // 跳转到直播详情
                    this.$router.push({ name: 'live-detail', params: { id: i.id } })
                }

            }

        },
        // 频道页面item跳转
        goChannel(item) {
            if (item.origin_type == 4) {
                Interface.goLiveDetail(this,{
                    id: item.origin_id,
                    type:item.type,
                    live_status: item.live_status
                })
            }else{
                Interface.goCourse(this, {
                    id:item.origin_id,
                    type:item.type,
                })
            }


        },
        goKf() {
            location.href = 'https://work.weixin.qq.com/kfid/kfc1ed5c3531beb6890'
        },
        goBanner(item) {
            Interface.mFootPrint(item.id,33,0,3,0, '')
        }
    },
    created() {
        this.fetch('banner')
        this.fetch('course')
        this.fetch('search_text')
        this.fetch('new_banner')
        Interface.initChannel("clinic")
        Interface.getShareInfo(this,'临床好课',"","精选实用课，堂堂有收获",39,'', Interface.host + '/#/clinic-course?source_type=1')
        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint(0, 39,0, 3, source_type, '临床好课')
        } else {
            Interface.mFootPrint('',39,0,3,0,'临床好课')
        }
    }
}
</script>

<style scoped lang="scss">
@import "./index.scss";

.course-detail-question-button {
    position: fixed;
    bottom: 205px;
    right: 5px;
    z-index: 2;
    width: 60px;
    height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/clinic-course/index.vue